// extracted by mini-css-extract-plugin
module.exports = {"container":"HueSlider_container__mo65m"};